module.exports = __webpack_public_path__ + "static/media/GLC-office.08f92037.svg";